<div class="so-list-table">
  @if (showTableHeader()) {
    <div class="so-list-table-header">
      <div class="so-list-table-header-left">
        @if (tableHeaderIcon()) {
          <so-premium-icon-ui
            [icon]="tableHeaderIcon()"
            [color]="tableHeaderIconColor()"
            [size]="18"
            [padding]="8"
            [borderRadius]="10" />
        }
        <div class="so-list-table-titles">
          @if (tableTitle()) {
            <span class="so-list-table-title">{{ tableTitle() }}</span>
          }
          @if (tableSubtitle()) {
            <span class="so-list-table-subtitle">{{ tableSubtitle() }}</span>
          }
        </div>
      </div>

      <div class="so-list-table-header-right">
        <ng-content select="[tableHeaderExtra]"></ng-content>

        @if (showTableActionButton()) {
          <so-button-gradient-ui
            [text]="tableActionButtonText()"
            [icon]="tableActionButtonIcon()"
            [disabled]="tableActionButtonDisabled()"
            (click)="tableActionButtonClicked.emit()" />
        }

        @if (showTableSearch()) {
          <so-input-ui
            #listSearchInput
            [placeholder]="tableSearchPlaceholder()"
            [type]="'search'"
            [inputHeight]="36"
            (input)="onSearchChange($any($event.target).value)" />
        }
      </div>
    </div>
  }

  <div class="so-list-table-toolbar-row">
    @if (showsColumnPicker()) {
      <so-column-picker-ui [columns]="pickerColumns()" [(hidden)]="hiddenColumns" />
    }

    <so-tabs-ui
      class="so-list-table-view-switch"
      [tabs]="viewTabs()"
      [display]="'pills'"
      [activeIndex]="viewIndex()"
      [showContent]="false"
      [contentCard]="false"
      (tabChanged)="onViewTabChanged($event)" />
  </div>

  @if (view() === 'dense') {
    <so-table-ui
      [tableData]="data()"
      [tableHeaders]="headers()"
      [density]="'dense'"
      [showTableHeader]="false"
      [hiddenColumns]="effectiveHiddenColumns()"
      [searchText]="internalSearchText()"
      [tableStyle]="tableStyle()"
      [headerStyle]="headerStyle()"
      [showInnerBorders]="showInnerBorders()"
      [striped]="striped()"
      [stickyLeftColumns]="stickyLeftColumns()"
      [stickyRightColumns]="stickyRightColumns()"
      [enableRowSelection]="enableRowSelection()"
      [isActionsEnabled]="isActionsEnabled()"
      [actionsDisplay]="actionsDisplay()"
      [buttonsContainerWidth]="buttonsContainerWidth()"
      [editAction]="false"
      [deleteAction]="false"
      [customButtons]="rowActions()"
      [showSwitches]="showSwitches()"
      [switchHeader]="switchHeader()"
      [switchIdentifier]="switchIdentifier()"
      [switchLabelLeft]="switchLabelLeft()"
      [switchLabelRight]="switchLabelRight()"
      [switchRowVisibilityFN]="switchRowVisibilityFN()"
      [switchRowResolverFN]="switchRowResolverFN()"
      [enablePagination]="enablePagination()"
      [paginationType]="paginationType()"
      [itemsPerPage]="itemsPerPage()"
      [pageSizeOptions]="pageSizeOptions()"
      [tokenPaginationState]="tokenPaginationState()"
      (editEvent)="editEvent.emit($event)"
      (deleteEvent)="deleteEvent.emit($event)"
      (rowClickedEvent)="rowClickedEvent.emit($event)"
      (switchEvent)="switchEvent.emit($event)"
      (nextPageRequested)="nextPageRequested.emit($event)"
      (previousPageRequested)="previousPageRequested.emit($event)"
      (pageSizeChanged)="pageSizeChanged.emit($event)" />
  } @else if (data().length === 0) {
    <div class="so-list-table-empty">Sin resultados</div>
  } @else {
    <div class="so-list-table-rows" role="list">
      @for (item of data(); track $index) {
        <div class="so-list-row" role="listitem">
          <div class="so-list-row-main">
            <span class="so-list-row-title">{{ compactRow().title(item) }}</span>
            <span class="so-list-row-meta">{{ metaText(item) }}</span>
          </div>

          @if (timelineOf(item); as timeline) {
            <div class="so-list-row-timeline">
              <span class="so-list-row-range">{{ rangeText(timeline) }}</span>
              @if (progressOf(timeline) !== null) {
                <div
                  class="so-list-row-progress"
                  role="progressbar"
                  [attr.aria-valuenow]="progressOf(timeline)"
                  aria-valuemin="0"
                  aria-valuemax="100">
                  <div class="so-list-row-progress-fill" [style.width.%]="progressOf(timeline)"></div>
                </div>
              }
              @if (timeline.statusText) {
                <span class="so-list-row-status">{{ timeline.statusText }}</span>
              }
            </div>
          }

          @if (compactRow().stats?.length) {
            <div class="so-list-row-stats">
              @for (stat of compactRow().stats; track stat.label) {
                <div class="so-list-row-stat">
                  @if (showsStat(stat, item)) {
                    <span class="so-list-row-stat-label">{{ stat.label }}</span>
                    @if (isStatLink(stat, item)) {
                      <button
                        type="button"
                        class="so-list-row-stat-value so-list-row-stat-link"
                        (click)="onStatLinkClick(stat, item)">{{ stat.value(item) }}</button>
                    } @else {
                      <span class="so-list-row-stat-value">{{ stat.value(item) }}</span>
                    }
                  }
                </div>
              }
            </div>
          }

          <div class="so-list-row-state">
            <div class="so-list-row-badge-slot">
              @if (compactRow().badge; as badge) {
                <so-badge-ui [text]="badge.text(item)" [color]="compactRow().badge!.color(item)" size="sm" />
              }
            </div>
            @if (compactRow().switchConfig; as switchConfig) {
              <div class="so-list-row-switch-slot">
                @if (showsSwitch(item)) {
                  <so-switch-ui
                    [isChecked]="switchConfig.checked(item)"
                    [isDisabled]="isSwitchDisabled(switchConfig, item)"
                    [width]="38"
                    [height]="20"
                    (statusChecked)="switchConfig.onChange(item, $event)" />
                }
              </div>
            }
          </div>

          @if (isActionsEnabled()) {
            <so-row-actions-menu-ui class="so-list-row-actions" [actions]="rowActions()" [item]="item" title="Acciones" />
          }
        </div>
      }
    </div>
  }

  @if (view() === 'compact' && showsCompactPagination()) {
    <div class="so-list-table-footer">
      <so-token-pagination-ui
        [tokenPaginationState]="tokenPaginationState()"
        [itemsPerPage]="itemsPerPage()"
        [pageSizeOptions]="pageSizeOptions()"
        [totalItems]="data().length"
        (nextPageRequested)="nextPageRequested.emit($event)"
        (previousPageRequested)="previousPageRequested.emit($event)"
        (pageSizeChanged)="pageSizeChanged.emit($event)" />
    </div>
  }
</div>
